import { useToggle } from "usehooks-ts";
import { Col } from "../Col";
import { Row } from "../Row";
import { ActionIconText } from "../ActionIconText";
import { ArrowDown } from "@/icons";

type Props = {
    title: string;
    toggleableLabel?: string;
    children: React.ReactNode;
    defaultOpen?: boolean;
}

export const AccordionContainer = ({ title, toggleableLabel = "", children, defaultOpen = true }: Props) => {

    const [isAccordionOpen, toggleAccordion] = useToggle(defaultOpen);

    return (
        <Col className="bg-lightblue-a03 p-x20 br-x8 shadow-sm">
            <Row justifyContent='space-between' className='mb-x24' alignItems='center'>
                <Col gap='x4'>
                    <h2 className="fs-5 fw-bold text-slate-100">{title}</h2>
                    {
                        !isAccordionOpen && <p className="fs-6 fw-regular text-slate-80">{toggleableLabel}</p>
                    }
                </Col>
                <ActionIconText textLabel='' iconColor='slate-20' handleAction={toggleAccordion} icon={<ArrowDown className={`cursor-pointer ${isAccordionOpen ? 'rotate-180' : ''}`} />} />
            </Row>

            {isAccordionOpen && <Col>{children}</Col>}
        </Col>
    )
}

